// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__3NtXE","list":"styles_list__13w9Z"};